var _excluded = ["position", "collapseBelow", "reverse"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React, { Children } from "react";
import styled, { css } from "styled-components";
import { spacing } from "@nib-components/theme";
import { Box } from "../Box";
import { Columns } from "../Columns";
import { Column } from "../Column";
import { breakpoint, map } from "../breakpoint";
import { breakpointPropTypes, spacingPropTypeMap } from "../utils"; // eslint-disable-next-line @typescript-eslint/no-unused-vars
export var ContainerWrapper = styled(function (_ref) {
  var position = _ref.position,
    collapseBelow = _ref.collapseBelow,
    reverse = _ref.reverse,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", ";\n"])), function (_ref2) {
  var collapseBelow = _ref2.collapseBelow,
    reverse = _ref2.reverse;
  return collapseBelow && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), breakpoint(collapseBelow)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", "\n      "])), function (_ref3) {
    var position = _ref3.position;
    return position === "left" ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                & > ", " {\n                  margin-left: ", ";\n                  margin-right: ", ";\n                }\n              "])), PartialContainer, reverse ? "unset" : "auto", reverse ? "auto" : "unset") : css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                & > ", " {\n                  margin-right: ", ";\n                  margin-left: ", ";\n                }\n              "])), PartialContainer, reverse ? "unset" : "unset", reverse ? "auto" : "unset");
  }));
});
export var PartialContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
  var padding = _ref4.padding,
    collapseBelow = _ref4.collapseBelow;
  return map(padding, function (val) {
    return val !== undefined && collapseBelow && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          ", ";\n        "])), breakpoint(collapseBelow)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            max-width: calc((75rem / 2) - ", ");\n          "])), spacing[val]));
  });
});
export var SplitSection = function SplitSection(_ref5) {
  var _ref5$padding = _ref5.padding,
    padding = _ref5$padding === void 0 ? {
      xs: 4,
      md: 6,
      lg: 8
    } : _ref5$padding,
    _ref5$collapseBelow = _ref5.collapseBelow,
    collapseBelow = _ref5$collapseBelow === void 0 ? "xs" : _ref5$collapseBelow,
    reverse = _ref5.reverse,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement(Columns, {
    "data-mesh-component": "SPLIT-SECTION",
    collapseBelow: collapseBelow,
    reverse: reverse
  }, Children.map(children, function (child, index) {
    if (index < 2 && /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.createElement(Column, {
        width: "1/2",
        flex: true
      }, /*#__PURE__*/React.createElement(ContainerWrapper, _extends({
        position: index === 0 ? "left" : "right",
        collapseBelow: collapseBelow,
        padding: padding,
        reverse: reverse
      }, child.props), /*#__PURE__*/React.cloneElement(child, {
        padding: padding,
        collapseBelow: collapseBelow,
        reverse: reverse
      })));
    }
    return null;
  }));
};
SplitSection.displayName = "SplitSection";
SplitSection.Item = PartialContainer;